"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockBuildIdentification = exports.mockScriptIdentification = exports.mockTaskIdentification = void 0;
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const utils_1 = require("../utils");
const identifiers_1 = require("../identifiers");
function mockTaskIdentification(organizationUid, opts = {}) {
    const { fixtureName } = opts, overrides = __rest(opts, ["fixtureName"]);
    const scriptIdent = mockScriptIdentification(organizationUid, { scriptBuildUid: fixtureName });
    const res = Object.assign(scriptIdent, {
        structureUid: 'fake0structureUid0',
        taskSid: `taskSid0${utils_1.weakRandomChars()}`,
    }, overrides);
    res.taskRuntimeUid = res.taskRuntimeUid || _fakeMd5(`${res.taskSid}_${res.kahbaRuntimeUid}`);
    return res;
}
exports.mockTaskIdentification = mockTaskIdentification;
function mockScriptIdentification(organizationUid, overrides = {}) {
    let res;
    res = lodash_merge_1.default(mockBuildIdentification(organizationUid), {
        authorEnv: identifiers_1.authorEnvForMainInPlatformUnitTest(),
        kahbaRuntimeUid: `test0${utils_1.createUid(7)}`,
    }, overrides);
    return res;
}
exports.mockScriptIdentification = mockScriptIdentification;
function mockBuildIdentification(organizationUid, overrides = {}) {
    if (typeof organizationUid !== 'string') {
        throw new Error('organizationUid required');
    }
    let res;
    res = lodash_merge_1.default({
        organizationUid,
        automationProjectUid: 'fakeAutomationProject01',
        scriptBuildUid: 'fake0scriptBuildUid',
    }, overrides);
    return res;
}
exports.mockBuildIdentification = mockBuildIdentification;
// todo: need isomorphic sha256 and md5 
function _fakeMd5(val) {
    return `fakedMd5_${val}`;
}
//# sourceMappingURL=mock-task-ident.js.map